import { render, staticRenderFns } from "./company-jput.vue?vue&type=template&id=810c2614&scoped=true&"
import script from "./company-jput.vue?vue&type=script&lang=js&"
export * from "./company-jput.vue?vue&type=script&lang=js&"
import style0 from "./company-jput.vue?vue&type=style&index=0&id=810c2614&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810c2614",
  null
  
)

export default component.exports